<template>
  <div class="flex flex-col h-screen">
    <!-- New Header Section -->
      <myheader @manageBooking="(data)=>triggerBooking()"></myheader>
    <!-- Main Content -->
    <router-view></router-view>
    <div class="flex-grow"></div>

    <myfooter></myfooter>
    <!-- Footer Section -->

    <!-- Update Booking Modal -->
    <update-booking
      :showManageBooking="showManageBooking"
      @update:showManageBooking="val => showManageBooking = val"
    />
  </div>
</template>

<script>
import updateBooking from '@/components/hawk/updateBooking.vue'
import { ref } from 'vue'
import myheader from './myheader.vue'
import myfooter from './myfooter.vue'

export default {
  components: {
    updateBooking,
    myheader,
    myfooter,
  },
  data() {
    return {
      showManageBooking: false,
      isMobileMenuOpen: false,
    };
  },
  methods: {
    triggerBooking(){
      this.showManageBooking = true;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    goback() {
      window.location.href = 'https://www.hawkrentacar.com.my';
    },
  },

};
</script>

<style scoped>
.group:hover .group-hover\:block {
  display: block;
}
</style>
